import { Box, Grid, Button, TextField } from "@mui/material";
import { FC, useState, useEffect } from "react";
import { load, remove } from "../../constants/storage";
import { H3, H4, H5, Small } from "../../components/Typography";
import {
  getLivePrices,
  getGoldCoins,
  giftingAPICall,
} from "../../redux/actions/GoldSilverAction";
import { maxPhoneLength } from "../../common/common";
import GiftingTopBanner from "../../components/GiftingTopBanner";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { EVENT_TYPES } from "../../constants/constant";
import { toast } from "react-hot-toast";
import { PAYMENT_URL_DEV, MERCHANTS_ID } from "../../common/common";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardNavbar from "../../components/DashboardNavbar";
type FormValues = {
  phoneNumber: string;
  recieverName: string;
};

type FormErrors = {
  phoneNumber?: string;
  recieverName?: string;
};
const Gifting: FC = () => {
  const [gift, setGift] = useState("Gold");
  const [selected, setSelected] = useState<any>();
  const [selectedGold, setSelectedGold] = useState(1);
  const [selectedSilver, setSelectedSilver] = useState(2);
  const [count, setCount] = useState(1);
  const [goldLivePrice, setGoldLivePrice] = useState();
  const [silverLivePrice, setSilverLivePrice] = useState();
  const [goldCoins, setGoldCoinsData] = useState([]);
  const [goldAmount, setGoldAmount] = useState<any>();
  const [silverAmount, setFinalSilverPrice] = useState<any>();
  const [amount, setAmount] = useState<any>();
  const [goldGram, setGoldGram] = useState<string>("1");
  const [silverGram, setSilverGram] = useState<string>("2");
  const [goldPriceWithGst, setGoldPriceWithGst] = useState<any>();
  const [silverPriceWithGst, setSilverPriceWithGst] = useState<any>();
  const [selectedOcasion, setSelectedOcasion] = useState<string>("Just Born");
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [formValues, setFormValues] = useState<FormValues>({
    phoneNumber: "",
    recieverName: "",
  });
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    if (name === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "");
      setFormValues({ ...formValues, [name]: numericValue });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
    setFormErrors({ ...formErrors, [name]: "" }); // clear any previous errors for this field
  }
  useEffect(() => {
    checkToken();
  }, [gift]);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getPrices();
      getCoins();
    }
  };

  const getPrices = async () => {
    let token = await load("token");
    dispatch(getLivePrices(token))
      .then(async (response: any) => {
        setSilverLivePrice(response.sBuy);
        setGoldLivePrice(response.gBuy);

        let goldPriceGst =
          parseFloat(response.gBuy) + parseFloat(response.gBuyGst);
        setGoldAmount(goldPriceGst.toFixed(2));

        let silverPriceGst =
          parseFloat(response.sBuy) + parseFloat(response.sBuyGst);
        setFinalSilverPrice(parseFloat(silverPriceGst.toFixed(2)) * 2);

        let final =
          gift === "Gold"
            ? goldPriceGst.toFixed(2)
            : gift === "Silver"
            ? silverPriceGst.toFixed(2)
            : null;
        setAmount(final);

        if (gift === "Gold") {
          setGoldPriceWithGst(goldPriceGst.toFixed(2));
          return;
        }
        if (gift === "Silver") {
          setSilverPriceWithGst(silverPriceGst.toFixed(2));
          return;
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getCoins = async () => {
    let token = await load("token");
    dispatch(getGoldCoins(token))
      .then(async (response: any) => {
        if (response.statusCode === 200) {
          setGoldCoinsData(response.data);
          setSelected(response.data[0]);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleIncrement = () => {
    setCount(count + 1);
  };

  const handleDecrement = () => {
    if (count === 0) {
      return;
    } else {
      setCount(count - 1);
    }
  };

  //Amount Edit
  const amountEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;
    if (value > 100000) {
      toast.error("Amount should not be greater than 100000 rupees.");
      return;
    }
    if (value <= 100000) {
      var totalGram: any = value / amount;
      totalGram = totalGram.toFixed(4);

      // New Logic
      if (totalGram <= 500) {
        setGoldGram(totalGram);
        setSilverGram(totalGram);
        setGoldAmount(value);
        setFinalSilverPrice(value);
      } else {
        toast.error("Please enter less then 500 Gm.");
      }
    }
  };

  //Gram Edit
  const grmEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;

    if (value > 500) {
      toast.error("Please enter less then 500 Gm.");
    } else {
      var totalAmmount: any = amount * value;
      var totalAmmount = totalAmmount.toFixed(2);
      if (totalAmmount <= 100000) {
        setGoldAmount(totalAmmount);
        setFinalSilverPrice(totalAmmount);
        setGoldGram(value);
        setSilverGram(value);
      } else {
        toast.error("Amount should not be greater then 100000 rupees.");
      }
    }
  };

  //Button
  const onButtonSelected = (item: any) => {
    var totalValue = item * amount;
    if (gift === "Gold") {
      setGoldGram(item);
      var totalAmmount = totalValue.toFixed(2);
      setGoldAmount(totalAmmount);
    } else {
      setSilverGram(item);
      var totalAmmount = totalValue.toFixed(2);
      setFinalSilverPrice(totalAmmount);
    }
  };

  const onProceed = async () => {
    const newErrors: FormErrors = {};

    if (formValues.phoneNumber === "") {
      newErrors.phoneNumber = "Phone number is required";
    }
    if (formValues.recieverName === "") {
      newErrors.recieverName = "Name is required";
    }
    if (goldAmount === "") {
      toast.error("Please enter gold amount");
      return;
    }
    if (goldAmount < 1) {
      toast.error("Please enter atleast Rs.1");
      return;
    }
    if (silverAmount === "") {
      toast.error("Please enter silver amount");
      return;
    }
    if (silverAmount < 1) {
      toast.error("Please enter atleast Rs.1");
      return;
    }
    // if there are errors, update state_name with them
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
    } else {
      setLoading(true);
      let token: any = load("token");
      let userDetail: any = load("userData");
      let user = JSON.parse(userDetail);
      const code = user.country_code ? user.country_code : "+91";
      var newValue = code.toString().slice(1);
      var finalData = JSON.stringify({
        senderMobile: newValue + user.mobile,
        receiverMobile: "91" + formValues.phoneNumber,
        senderName: user.firstname + " " + user.lastname,
        receiverName: formValues.recieverName,
        purpose: selectedOcasion,
        giftType: gift.toLowerCase(),
        amount: gift === "Gold" ? goldAmount : silverAmount,
        quantity:
          gift === "Gold"
            ? parseFloat(goldGram).toFixed(4)
            : parseFloat(silverGram).toFixed(4),
        senderUserId: user.id,
        source: "partner",
        callBackUrl: process.env.REACT_APP_GS_CALL_BACK_URL,
      });
      await dispatch(giftingAPICall(finalData, token))
        .then(async (response: any) => {
          setLoading(false);
          if (response?.status === 401) {
            return;
          }
          if (response.errorCode === "200") {
            let newWindow: any = window.open("", "_self");
            await newWindow.document.write(`
              <html>
                <head>
                  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
                  <title>Acru - Financial Wellness for All</title>
                </head>
                <body>
                  <div id="waiting" style="display: block; font-family: sans-serif;">
                    <br /><br />
                    <center><h1>Please wait!</h1><h2> Do not refresh the page</h2></center>
                  </div>
                  <div id="done" style="display: none; font-family: sans-serif;">
                    <br /><br />
                    <center><h2>Payment has been cancelled.</h2><h4><nav><a href="/dashboard">Retry</a></nav></h4></center>
                  </div>
                  <div id="paytm-checkoutjs"></div>
                  <script>
                    function hidewaiting() {
                      setTimeout(() => {
                        document.getElementById("waiting").style.display = "none";
                      }, 10000);
                    }
                    
                    function showdone() {
                      setTimeout(() => {
                        document.getElementById("done").style.display = "block";
                      }, 10000);
                    }
                    
                    function onScriptLoad() {
                      var config = {
                        root: "",
                        flow: "DEFAULT",
                        data: {
                          "orderId": "${response.orderId}",
                          "token": "${response.txn_token}",
                          "tokenType": "TXN_TOKEN",
                          "amount": "${response.amount}"
                        },
                        handler: {
                          notifyMerchant: function(eventName, data) {
                            console.log("eventName => ", eventName);
                            console.log("data => ", data);
                            if (eventName === "APP_CLOSED") {
                              showdone();
                              hidewaiting();
                              console.log("ddd");
                            } else {
                              showdone();
                            }
                            console.log("eventName => ", eventName);
                            console.log("data:::-->>", data.message);
                          }
                        },
                      };
                      
                      if (window.Paytm && window.Paytm.CheckoutJS) {
                        window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                          window.Paytm.CheckoutJS.init(config)
                            .then(function onSuccess() {
                              window.Paytm.CheckoutJS.invoke();
                            })
                            .catch(function onError(error) {
                              console.log("error => ", error);
                            });
                        });
                      }
                      
                      window.history.pushState(null, null, window.location.href);
                      window.onpopstate = function() {
                        window.history.pushState(null, null, window.location.href);
                      };
                    }
            
                    var scriptTag = document.createElement("script");
                    scriptTag.type = "application/javascript";
                    scriptTag.crossOrigin = "anonymous";
                    scriptTag.src = "${PAYMENT_URL_DEV}/merchantpgpui/checkoutjs/merchants/${MERCHANTS_ID}.js";
                    scriptTag.onload = onScriptLoad;
            
                    document.body.appendChild(scriptTag);
                  </script>
                </body>
              </html>
            `);
          } else {
            toast.error(response.errorMsg);
          }
        })
        .catch((error: any) => {
          alert("We got error, Please try after sometimes!");
          setLoading(false);
        });
    }
  };

  const onGiftCoin = () => {
    navigate("/coinpriceBreakup", {
      state: {
        screenName: "GoldCoin",
        selected: selected,
      },
    });
  };

  return (
    <>
      <DashboardNavbar />
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
          }}
        >
          <GiftingTopBanner />

          <Grid
            xs={12}
            md={8}
            sx={{
              mt: 2,
              mb: 2,
              height: "100%",
              backgroundColor: "#fff",
              borderRadius: 2,
              boxShadow: {
                md: 1,
                xs: 0,
              },
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: {
                  md: 3,
                  xs: 3,
                  sm: 4,
                },
                pt: {
                  xs: 1,
                },
                width: "95%",
              }}
            >
              <H3
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  mb: 1,
                }}
              >
                Gifting
              </H3>
              <H4
                color="#141414"
                fontWeight={"600"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Whom do you wish to gift
              </H4>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  onProceed();
                }}
              >
                <Box
                  sx={{
                    flexDirection: {
                      md: "row",
                      xs: "column",
                    },
                    mt: 2,
                    display: "flex",
                    pb: 2,
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "60%",
                    },
                  }}
                >
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Reciever's Name
                    </H4>
                    <TextField
                      name="recieverName"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "40px", // change this value to set the desired height
                        },
                      }}
                      value={
                        formValues.recieverName ? formValues.recieverName : ""
                      }
                      error={!!formErrors.recieverName}
                      helperText={formErrors.recieverName}
                      onChange={handleChange}
                      placeholder="eg: John Doe"
                    />
                  </Box>
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                      mt: {
                        md: 0,
                        sm: 1,
                        xs: 1,
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Reciever's Mobile No.
                    </H4>
                    <TextField
                      name="phoneNumber"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "40px", // change this value to set the desired height
                        },
                      }}
                      value={
                        formValues.phoneNumber ? formValues.phoneNumber : ""
                      }
                      inputProps={{
                        maxLength: maxPhoneLength,
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}
                      error={!!formErrors.phoneNumber}
                      helperText={formErrors.phoneNumber}
                      onChange={handleChange}
                      placeholder="eg: 123456789"
                    />
                  </Box>
                </Box>
              </form>
              <H4
                color="#141414"
                fontWeight={"600"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                What’s the occasion?
              </H4>
              <Grid
                container
                sx={{
                  pb: 5,
                  pt: 2,
                  justifyContent: {
                    xs: "space-around",
                    sm: "space-between",
                    md: "flex-start",
                  },
                }}
              >
                {EVENT_TYPES.map((item: any) => (
                  <Box
                    sx={{
                      width: {
                        xs: 100,
                        sm: 80,
                        md: 140,
                      },
                      mt: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <Button
                      disableTouchRipple={true}
                      disableElevation={true}
                      disableRipple={true}
                      onClick={() => setSelectedOcasion(item.title)}
                      sx={{
                        alignItems: "center",
                        justifyItems: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "row",
                          objectFit: "contain",
                        }}
                      >
                        <Box
                          sx={{
                            background:
                              selectedOcasion === item.title
                                ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                                : "#F9F8F7",
                            boxShadow: 2,
                            p: 1,
                            borderRadius: "50%",
                            mb: {
                              md: 2,
                              xs: 1,
                              sm: 1,
                            },
                            height: 40,
                            width: 40,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: 30,
                              minwidth: 30,
                              mt: 0.5,
                            }}
                            src={
                              selectedOcasion === item.title
                                ? item.selectedicon
                                : item.icon
                            }
                            alt="saas-dasboard-footer"
                          />
                        </Box>
                      </Box>
                      <H5
                        color="#595959"
                        fontWeight={"400"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {item.title}
                      </H5>
                    </Button>
                  </Box>
                ))}
              </Grid>
            </Box>
            <Box
              sx={{
                width: "100%",
                borderRadius: 2,
                pb: 1,

                display: "flex",
                flexDirection: "row",
              }}
            >
              <Button
                onClick={() => {
                  setGift("Gold");
                  setGoldGram("1");
                }}
                disableElevation
                disableRipple
                size="medium"
                sx={{
                  background:
                    gift === "Gold"
                      ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                      : "#F6F6F6",
                  color: gift === "Gold" ? "#fff" : "#000",
                  width: "50%",
                  borderBottomRightRadius: 0,
                  borderTopRightRadius: 0,
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  pt: 1.5,
                  pb: 1.5,
                  textTransform: "none",
                  "&:hover": {
                    background:
                      gift === "Gold"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                  },
                }}
              >
                Gift Digital Gold
              </Button>
              <Button
                disableElevation
                disableRipple
                onClick={() => {
                  setGift("Silver");
                  setSilverGram("2");
                }}
                size="medium"
                sx={{
                  background:
                    gift === "Silver"
                      ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                      : "#F6F6F6",
                  color: gift === "Silver" ? "#fff" : "#000",
                  width: "50%",
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  borderTopRightRadius: 0,
                  textTransform: "none",
                  "&:hover": {
                    background:
                      gift === "Silver"
                        ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                        : "#F6F6F6",
                  },
                }}
              >
                Gift Digital Silver
              </Button>
            </Box>
            {gift === "Gold" && (
              <Box
                sx={{
                  padding: {
                    md: 3,
                    xs: 0,
                    sm: 2,
                  },
                  width: {
                    md: "30%",
                    xs: "100%",
                  },
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: {
                    md: 3,
                    xs: 0,
                  },
                  m: 2,
                  borderRadius: 4,
                }}
              >
                <H4
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  fontWeight={"500"}
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    mb: 1,
                    ml: {
                      xs: 4,
                    },
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Gift Digital Gold
                </H4>
                <Box
                  sx={{
                    flexDirection: {
                      md: "row",
                      xs: "column",
                    },
                    display: "flex",
                    paddingX: 2,
                    paddingY: 0.5,
                    pb: 2,
                  }}
                >
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Amount
                    </H4>
                    <TextField
                      name="amount"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px",
                        },
                      }}
                      onChange={amountEdit}
                      value={goldAmount}
                    />
                  </Box>
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                      mt: {
                        md: 0,
                        sm: 1,
                        xs: 1,
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Grams
                    </H4>
                    <TextField
                      name="grams"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px", // change this value to set the desired height
                        },
                      }}
                      value={goldGram}
                      onChange={grmEdit}
                    />
                  </Box>
                </Box>
                <Grid
                  spacing={2}
                  sx={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "stretch",
                    width: "100%",
                    alignSelf: "center",
                    padddingY: 20,
                    pb: 1,
                  }}
                >
                  {[1, 3, 5, 10].map((item, index) => (
                    <Box
                      onClick={() => {
                        onButtonSelected(item);
                        setSelectedGold(item);
                      }}
                      sx={{
                        background:
                          item === selectedGold
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                        borderRadius: 2,
                        p: 1,
                        pt: 0.4,
                        cursor: "pointer",
                      }}
                    >
                      <Small
                        fontWeight={"600"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",

                          color: item === selectedGold ? "#fff" : "#000",
                        }}
                      >
                        {item} Gm
                      </Small>
                    </Box>
                  ))}
                </Grid>
                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    marginY: 0.4,
                  }}
                  fontWeight={"700"}
                >
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {" "}
                    Gold live price:{" "}
                  </Small>
                  ₹
                  <Small
                    fontWeight={"700"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {goldLivePrice}/Gm
                  </Small>
                </Small>
                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    mt: 0.4,
                    mb: 1,

                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Price valid for:{" "}
                  <Small
                    fontWeight={"700"}
                    color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    05:00 min
                  </Small>
                </Small>
                <Box
                  sx={{
                    background:
                      "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                    p: 0.7,
                    pl: 2,
                    pr: 2,
                    borderRadius: 2,
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 0.2,
                    mb: 1,
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      height: 15,
                      minwidth: 15,

                      mr: 1,
                      mt: -0.2,
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/secure.svg"
                    alt="saas-dasboard-footer"
                  />
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    24K Gold with 999 Purity
                  </Small>
                </Box>
                <Button
                  onClick={onProceed}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    color: "#fff",
                    width: {
                      md: "50%",
                      xs: "80%",
                    },
                    mb: 1,
                    textTransform: "none",
                  }}
                >
                  Proceed
                </Button>
              </Box>
            )}
            {gift === "Silver" && (
              <Box
                sx={{
                  padding: {
                    md: 3,
                    xs: 0,
                    sm: 2,
                  },
                  width: {
                    md: "30%",
                    xs: "100%",
                  },
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: {
                    md: 3,
                    xs: 0,
                  },
                  m: 2,
                  borderRadius: 4,
                }}
              >
                <H4
                  color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                  fontWeight={"500"}
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    mb: 1,
                    ml: 4,
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Gift Digital Silver
                </H4>
                {/* TextInputs */}
                <Box
                  sx={{
                    flexDirection: {
                      md: "row",
                      xs: "column",
                    },
                    display: "flex",
                    paddingX: 2,
                    paddingY: 0.5,
                    pb: 2,
                  }}
                >
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Amount
                    </H4>
                    <TextField
                      name="amount"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px", // change this value to set the desired height
                        },
                      }}
                      onChange={amountEdit}
                      value={silverAmount}
                    />
                  </Box>
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                      mt: {
                        md: 0,
                        sm: 1,
                        xs: 1,
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Grams
                    </H4>
                    <TextField
                      name="grams"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px", // change this value to set the desired height
                        },
                      }}
                      value={silverGram}
                      onChange={grmEdit}
                    />
                  </Box>
                </Box>
                <Grid
                  spacing={2}
                  sx={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "stretch",
                    width: "100%",
                    alignSelf: "center",
                    padddingY: 20,
                    pb: 1,
                  }}
                >
                  {[2, 10, 50, 100].map((item, index) => (
                    <Box
                      onClick={() => {
                        onButtonSelected(item);
                        setSelectedSilver(item);
                      }}
                      sx={{
                        background:
                          item === selectedSilver
                            ? process.env.REACT_APP_PRIMARY_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                        borderRadius: 2,
                        p: 1,
                        pt: 0.4,
                        cursor: "pointer",
                      }}
                    >
                      <Small
                        fontWeight={"600"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",

                          color: item === selectedSilver ? "#fff" : "#000",
                        }}
                      >
                        {item}Gm
                      </Small>
                    </Box>
                  ))}
                </Grid>
                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    marginY: 0.4,
                  }}
                  fontWeight={"700"}
                >
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Silver live price:{" "}
                  </Small>
                  ₹
                  <Small
                    fontWeight={"700"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {silverLivePrice}/Gm
                  </Small>
                </Small>
                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    mt: 0.4,
                    mb: 1,
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Price valid for:{" "}
                  <Small
                    fontWeight={"700"}
                    color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    05:00 min
                  </Small>
                </Small>
                <Box
                  sx={{
                    background:
                      "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
                    p: 0.7,
                    pl: 2,
                    pr: 2,
                    borderRadius: 2,
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 0.2,
                    mb: 1,
                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      height: 15,
                      minwidth: 15,

                      mr: 1,
                      mt: -0.2,
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/secure.svg"
                    alt="saas-dasboard-footer"
                  />
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    24K Silver with 999 Purity
                  </Small>
                </Box>
                <Button
                  onClick={onProceed}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    color: "#fff",
                    width: {
                      md: "50%",
                      xs: "80%",
                    },
                    mb: 1,
                    textTransform: "none",
                  }}
                >
                  Proceed
                </Button>
              </Box>
            )}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default Gifting;
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.2,
};
